/**
 * Best Sellers / New Arrivals Tabs
 * Handles category tab filtering and slider scroll for single product list.
 * Used by MNM Best Sellers section (section-new-arrivals-tabs).
 */

class NewArrivalsTabsSection {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.categoryTabs = this.section.querySelectorAll('.new-arrivals__category-tab');
    this.productItems = this.section.querySelectorAll('.new-arrivals__product-item');
    this.slider = this.section.querySelector('.new-arrivals__slider');
    this.activeCategory = null;

    if (!this.section || this.categoryTabs.length === 0) return;

    this.init();
  }

  init() {
    this.categoryTabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const category = tab.dataset.category;
        this.filterByCategory(category);
        this.updateActiveTab(tab);
      });
    });

    if (this.categoryTabs.length > 0) {
      const firstCategory = this.categoryTabs[0].dataset.category;
      this.filterByCategory(firstCategory);
    }
  }

  filterByCategory(category) {
    this.activeCategory = category;

    this.productItems.forEach((item) => {
      const itemCategory = item.dataset.category;

      if (itemCategory === category) {
        item.classList.add('new-arrivals__product-item--visible');
        item.style.display = 'block';
      } else {
        item.classList.remove('new-arrivals__product-item--visible');
        item.style.display = 'none';
      }
    });

    this.updateSliderCounter();

    const firstVisible = this.section.querySelector('.new-arrivals__product-item--visible');
    if (firstVisible && this.slider) {
      const sliderContainer = this.slider.querySelector('.slider');
      if (sliderContainer) {
        const scrollPosition = firstVisible.offsetLeft - sliderContainer.offsetLeft;
        sliderContainer.scrollTo({
          left: Math.max(0, scrollPosition),
          behavior: 'smooth'
        });
      }
    }
  }

  updateActiveTab(activeTab) {
    this.categoryTabs.forEach((tab) => {
      tab.classList.remove('new-arrivals__category-tab--active');
      tab.setAttribute('aria-selected', 'false');
    });

    activeTab.classList.add('new-arrivals__category-tab--active');
    activeTab.setAttribute('aria-selected', 'true');
  }

  updateSliderCounter() {
    const totalCounter = this.section.querySelector('.slider-counter--total');
    const currentCounter = this.section.querySelector('.slider-counter--current');
    const visibleItems = this.section.querySelectorAll('.new-arrivals__product-item--visible');

    if (totalCounter) {
      totalCounter.textContent = visibleItems.length;
    }
    if (currentCounter) {
      currentCounter.textContent = '1';
    }
  }
}

function initNewArrivalsTabsSections() {
  const sections = document.querySelectorAll('.section-new-arrivals-tabs');

  sections.forEach((section) => {
    const instance = new NewArrivalsTabsSection(section);
    section._newArrivalsTabsInstance = instance;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNewArrivalsTabsSections);
} else {
  initNewArrivalsTabsSections();
}

document.addEventListener('shopify:section:load', (event) => {
  const container = event.target;
  const section = container.querySelector && container.querySelector('.section-new-arrivals-tabs');
  if (section) {
    const instance = new NewArrivalsTabsSection(section);
    section._newArrivalsTabsInstance = instance;
  }
});

document.addEventListener('shopify:section:reorder', () => {
  initNewArrivalsTabsSections();
});

document.addEventListener('shopify:section:select', (event) => {
  const section = event.target && event.target.querySelector('.section-new-arrivals-tabs');
  if (section) {
    const instance = new NewArrivalsTabsSection(section);
    section._newArrivalsTabsInstance = instance;
  }
});
